import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/base/base.component';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { Config } from 'src/infrastructure/config';
import { Automapper } from 'src/infrastructure/core/automapper';
import { Errors } from 'src/infrastructure/labels/errors';
import { Successes } from 'src/infrastructure/labels/successes';
import { ValidationConfig } from 'src/infrastructure/validation/validationConfig';
import { Validator } from 'src/infrastructure/validation/validator';
import { createRequestRegistrationModel } from 'src/models/requestModels/user/createRegistrationRequestModel';
import { LocalstorageService } from 'src/services/core/localstorage/localstorage.service';
import { ToastService } from 'src/services/core/toast/toast.service';
import { AuthenticationService } from 'src/services/request/authentication/authentication.service';
import { UserInfoService } from 'src/services/request/user/userinfo.service';
import { HistoryService } from 'src/services/state/history/history.service';
import { LoggedUserService } from 'src/services/state/loggeduser/loggeduser.service';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css']
})
export class RegistrationComponent extends HistoryBaseComponent implements OnInit {

  registrationInfo: FormGroup;
  isCapitalLettersCheckValid = false;
  isSmallLettersCheckValid = false;
  isDigitsCheckValid = false;
  isLengthCheckValid = false;
  isSymbolCheckValid = false;

  constructor(
    private FB: FormBuilder,
    private toastr: ToastService,
    private registrationService: AuthenticationService,
    private router: Router,
    private localStorageService: LocalstorageService,
    protected location: Location,
    private userInfoService: UserInfoService,
    private userStateService: LoggedUserService,
    protected historyService: HistoryService

  ) {
    super(location, historyService);
    this.pageTitle = 'registration';
    this.registrationInfo = FB.group({
      first_name: ['', [Validators.required, Validators.pattern(ValidationConfig.regexes.cyrylicFull)]],
      last_name: ['', [Validators.required, Validators.pattern(ValidationConfig.regexes.cyrylicFull)]],
      email: ['', [Validators.required, Validators.pattern(ValidationConfig.regexes.email)]],
      password: ['', [Validators.required, Validators.minLength(8), Validator.ReactiveFormsValidators.passwordValidator]],
      password_confirmation: ['', [Validators.required, Validators.minLength(8), Validator.ReactiveFormsValidators.passwordValidator]],
      date_of_birth: ['20/10/1994',  [Validators.required]]
    })
  }

  ngOnInit(): void {
  }

  registration() {
    this._error = Validator.FormGroupValidator.validate(this.registrationInfo);
    if (this._error) {
      this.toastr.error(Errors.bg.invalidFields);
      this._error = '';
      return;
    }
    if (!Validator.InputValidator.password.confirmPasswords(
      this.registrationInfo.get('password')?.value,
      this.registrationInfo.get('password_confirmation')?.value
    )) {
        this.toastr.error(Errors.bg.passwordMatch);
        this._error = '';
        return;

    }
    if (!Validator.InputValidator.email.validate(this.registrationInfo.get('email')?.value)) {
      this._error = Errors.bg.invalidEmail;
      this.toastr.error(Errors.bg.invalidEmail);
      this._error = '';
      return;

    }
    let requestRegistrationModel : createRequestRegistrationModel = {} as any;
    Automapper.FGToObject.map(this.registrationInfo, requestRegistrationModel);
    requestRegistrationModel.telephone_info = 'Въведи';
    this.registrationService.createRegistration(requestRegistrationModel).subscribe(() => {
      this.toastr.success(Successes.bg.createUser);
      this.login()
    })

  }
  goToLogin() {
    this.router.navigate(['login']);
  }

  checkPassoword(passwordEventTarget: EventTarget | null) {
    if (!passwordEventTarget) return;
    const password = (passwordEventTarget as HTMLInputElement).value;
    this.checkForCapitalLetters(password);
    this.checkForLength(password);
    this.checkForSmallLetters(password);
    this.checkForDigit(password);
    this.checkForSymbol(password);
  }

  checkForCapitalLetters(password: string) {
    this.isCapitalLettersCheckValid = password.search(/[A-ZА-Я]/) >= 0

  }

  checkForLength(password: string) {
    this.isLengthCheckValid = password.length >= 8;
  }

  checkForSmallLetters(password: string) {
    this.isSmallLettersCheckValid = password.search(/[a-zа-я]/) >= 0
  }

  checkForDigit(password: string) {
    this.isDigitsCheckValid = password.search(/\d/) >= 0
  }

  checkForSymbol(password: string) {
    this.isSymbolCheckValid = password.search(/\W/) >= 0
  }

  login() {
    this.registrationService.loginUser({
      password: this.registrationInfo.get('password')?.value,
      rememberMe: true,
      email: this.registrationInfo.get('email')?.value
    }).subscribe((authToken) => {
      this.localStorageService.setLocalStorageItem(Config.lsTokenKey, authToken.data.token);
      this.userInfoService.loadUser().subscribe(user => {
        this.userStateService.addNewUser(user);
        this.router.navigate(['bottomtabs/home/']);
      })
    })
  }

  trim(emailEvent: EventTarget | null) {
    if (!emailEvent) return;
    let email = (emailEvent as HTMLInputElement).value;
    email = email.trim();
    this.registrationInfo.get('email')?.setValue(email);
  }
}
